import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
/** renders children inside of a flex containers */

var DisplayConfiguration = function DisplayConfiguration(_ref) {
  var _ref$additionalStyles = _ref.additionalStyles,
      additionalStyles = _ref$additionalStyles === void 0 ? [] : _ref$additionalStyles,
      children = _ref.children,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? [] : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$configContainerC = _ref.configContainerClass,
      configContainerClass = _ref$configContainerC === void 0 ? '' : _ref$configContainerC;
  var dataProps = {};

  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }

  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }

  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = 'display-configuration';
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, dataProps, {
    className: "".concat(configContainerClass, " display-config-container")
  }), React.Children.toArray(children).slice(0, styles.length).map(function (child, index) {
    var style = _objectSpread2(_objectSpread2({}, styles[index]), additionalStyles[index]);

    return /*#__PURE__*/React.createElement("div", {
      style: style,
      key: child.key || index,
      className: className
    }, child);
  }));
};

DisplayConfiguration.displayName = "DisplayConfiguration";
DisplayConfiguration.propTypes = {
  additionalStyles: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  className: PropTypes.string,
  configContainerClass: PropTypes.string,
  data: PropTypes.object,
  styles: PropTypes.arrayOf(PropTypes.object)
};
export { DisplayConfiguration };